module.exports = __webpack_public_path__ + "static/media/bosch_logo.6bdaeda5.svg";